module.exports = __webpack_public_path__ + "img/card-offer-carrot.02351463.png";